export const DEFAULT_PASSWORD_DIFFICULTY_BAR_COLOR = '#7A7D85';